import React from 'react';
import { Outlet } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import StaffNavbar from './StaffNavbar';
import WorkflowAlertToast from '../../components/WorkflowAlertToast';

const StaffLayout = () => (
  <ProtectedRoute allowedRoles={['seller', 'services', 'installations', 'demos', 'admin']}>
    <div className="min-h-screen bg-gray-50">
      <StaffNavbar />
      <main className="mx-auto w-full max-w-5xl px-4 py-6 sm:px-6 lg:px-8">
        <Outlet />
      </main>
      <WorkflowAlertToast />
    </div>
  </ProtectedRoute>
);

export default StaffLayout;
